import { supabase } from './supabase'

/**
 * Get outcomes for a care plan
 */
export const getCarePlanOutcomes = async (carePlanId, organizationId) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_outcomes')
      .select('*, recorded_by_user:recorded_by(email, raw_user_meta_data)')
      .eq('care_plan_id', carePlanId)
      .eq('organization_id', organizationId)
      .order('recorded_date', { ascending: false })

    if (error) throw error
    return data || []
  } catch (error) {
    console.error('Error fetching outcomes:', error)
    throw error
  }
}

/**
 * Create outcome record
 */
export const createOutcome = async (outcomeData) => {
  try {
    const { data: { user } } = await supabase.auth.getUser()
    
    const { data, error } = await supabase
      .from('care_plan_outcomes')
      .insert({
        organization_id: outcomeData.organizationId,
        care_plan_id: outcomeData.carePlanId,
        client_id: outcomeData.clientId,
        outcome_type: outcomeData.outcomeType,
        outcome_description: outcomeData.description,
        measurement_value: outcomeData.measurementValue || null,
        measurement_unit: outcomeData.measurementUnit || null,
        baseline_value: outcomeData.baselineValue || null,
        recorded_date: outcomeData.recordedDate || new Date().toISOString(),
        recorded_by: user?.id,
      })
      .select()
      .single()

    if (error) throw error
    return data
  } catch (error) {
    console.error('Error creating outcome:', error)
    throw error
  }
}

/**
 * Get outcome analytics
 */
export const getOutcomeAnalytics = async (carePlanId, organizationId) => {
  try {
    const { data, error } = await supabase
      .from('care_plan_outcomes')
      .select('*')
      .eq('care_plan_id', carePlanId)
      .eq('organization_id', organizationId)

    if (error) throw error

    const outcomes = data || []
    const goalAchieved = outcomes.filter((o) => o.outcome_type === 'goal_achieved').length
    const totalOutcomes = outcomes.length
    const achievementRate = totalOutcomes > 0 ? (goalAchieved / totalOutcomes) * 100 : 0

    return {
      totalOutcomes,
      goalAchieved,
      achievementRate: Math.round(achievementRate * 100) / 100,
      outcomesByType: {
        goal_achieved: outcomes.filter((o) => o.outcome_type === 'goal_achieved').length,
        symptom_improvement: outcomes.filter((o) => o.outcome_type === 'symptom_improvement').length,
        metric_change: outcomes.filter((o) => o.outcome_type === 'metric_change').length,
        client_feedback: outcomes.filter((o) => o.outcome_type === 'client_feedback').length,
        practitioner_assessment: outcomes.filter((o) => o.outcome_type === 'practitioner_assessment').length,
      },
    }
  } catch (error) {
    console.error('Error fetching outcome analytics:', error)
    throw error
  }
}

